<template>
  <div>
    <button @click="open" class="btn btn-outline-success btn-xs">{{ text ?? 'Согласовать' }}</button>
  </div>
</template>
<script>
import store from "@/store";

export default {
  props: ['order', 'text', 'component'],
  data() {
    return {}
  },
  methods: {
    open() {
      store.dispatch("platform/setGlobalModalData", {
        ...{
          type: this.component ?? 'newOrderAgreement',
          order: this.order
        }
      });
    }
  }
}
</script>
